
export default {
  name: 'workgroup',
  data: () => ({
    workgroups: [],
    all_employees: [],
    get_data: true
  }),
  methods: {
    async get_all_employees() {
      const res = this.$communicator.then(this, await this.$communicator('all_employees', {
        params: {}
      }))
      if (res) {
        this.all_employees = res
      }
    },
    async update_workgroup() {
      this.workgroups = this.$communicator.then(this, await this.$communicator('update_workgroup', {
        params: this.workgroups
      }))
    },
    async get_workgroup() {
      let aadditional = []
      if (this.additionalOrders) {
        aadditional = [{
          name: this.$t("orders"),
          _id: 'undefined'
        }]
      }
      const result = this.$communicator.then(this, await this.$communicator('get_workgroup'))
      if (result instanceof Array) {
        for (const index in result) {
          result[index].position_index = 1;
        }
        this.workgroups = aadditional.concat(result);
      }
    },
    add_workgroups() {
      if (this.workgroups.length === 0 || this.workgroups[this.workgroups.length - 1].name !== null)
        this.workgroups.push({ name: null })
    },
  },
  computed: {
    all_employees_() {
      const all_employees = [{ name: this.$t('all_employees'), _id: '' }, ...this.all_employees]
      this.res = all_employees[0]
      return all_employees
    }
  },
  mounted() {
    if (this.get_data) {
      this.get_workgroup()
      this.get_all_employees()
    }
  }
}
